import { useModalState } from '~/types';
import * as S from './Modal.styled';

type ModalViewProps = Omit<useModalState, 'isOpen'> & {
  handleActionButton?: () => void;
  handleLeftButton?: () => void;
  handleBackgroundClick?: () => void;
};

export default function ModalView({
  type,
  title,
  content,
  buttonName,
  leftButtonName,
  handleActionButton,
  handleLeftButton,
  handleBackgroundClick,
}: ModalViewProps) {
  const onBgClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (handleBackgroundClick) {
      handleBackgroundClick();
    }
  };
  return (
    <>
      <S.Container className='Modal'>
        <S.ContentWrapper>
          <S.TitleBox>
            <S.Title>{title}</S.Title>
          </S.TitleBox>
          <S.DescBox>
            <S.Desc>{content}</S.Desc>
          </S.DescBox>
        </S.ContentWrapper>
        <S.ButtonWrapper type={type ? type : 'double_red'}>
          {type === 'single' ? (
            <>
              <S.SingleButtonBox>
                <button onClick={handleActionButton}>{buttonName}</button>
              </S.SingleButtonBox>
            </>
          ) : (
            <>
              <S.LeftButtonBox
                type={type ? type : 'double_red'}
                className={`left`}
              >
                <button onClick={handleLeftButton}>
                  {leftButtonName ? leftButtonName : 'Cancel'}
                </button>
              </S.LeftButtonBox>
              <S.RightButtonBox
                type={type ? type : 'double_red'}
                className={`right`}
              >
                <button onClick={handleActionButton}>{buttonName}</button>
              </S.RightButtonBox>
            </>
          )}
        </S.ButtonWrapper>
      </S.Container>
      <S.Background onClick={onBgClick} className='background' />
    </>
  );
}
